import { createMuiTheme } from '@material-ui/core/styles';
import TouchRipple from '@material-ui/core/ButtonBase/TouchRipple';

TouchRipple.prototype.render = () => null;

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: '#2c9fdd',
      contrastText: '#fff',
    },
    secondary: {
      main: '#ff5581',
      contrastText: '#fff',
    },
    // Custom
    green: '#7db038',
    red: '#e65050',
    blue: '#44aeff',
    yellow: '#ffd535',
  },
});

export default theme;
